<template>
  <div>
    <!-- ヘッダ -->
    <comHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username" :propMenuInfo2="companyname"></comHeaderAuth>
    <!-- メイン -->
    <v-main>
      <v-container fluid>
        <!-- メッセージエリア -->
        <v-alert border="bottom" colored-border type="warning" elevation="2">
          {{ messageArea }}
        </v-alert>
        <!-- 注意事項 -->
        <v-card elevation="2" height="65vh">
          <v-card-text>
            <p class="text-h5 under" style="max-width: 200px; font-weight: bold;">■注意事項</p>
            <span v-html="notes"></span>
          </v-card-text>
        </v-card>
        <!-- ボタンエリア -->
        <v-row>
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            <v-checkbox v-model="unsubscribeCheck">
              <template v-slot:label>
                注意事項を読んだ上で、退会(アカウント削除)を希望する
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row style="margin-top: 0px !important;">
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            <v-btn :disabled="isProcessing" x-large color="warning" min-width="200px"  @click="suspend()">アカウントを削除する</v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            <v-btn x-large color="warning" min-width="200px" @click="cancel()">アカウントを削除しない</v-btn>
          </v-col>
        </v-row>

        <v-row class="mt-8" style="height: 10vh;"></v-row>
      
      </v-container>
    </v-main>
    <!-- フッター -->
    <!-- 利用規約 プライバシーポリシー 特定商取引法に基づく表記 -->
    <!-- <comFooterAuth :contactUsDspFlg="contactUsDspFlg" :moveTopDspPos="moveTopButtonPos" :propSrcScreenId="screenId"></comFooterAuth> -->
    <!-- その他 -->
    <comMessage :msg="dlgMsg.msg" :isOpen="dlgMsg.isOpen" :doYes="dlgMsg.doYes"/>
    <comMessage :msg="dlgMsgCompd.msg" :isOpen="dlgMsgCompd.isOpen" :doYes="dlgMsgCompd.doYes"/>
  </div>
</template>


<script>
import Constants from '../common/constants';
import Utils from '../common/utils';
export default {
  name: "AccountSuspend",
  data() {
    return {
      username: "",
      companyname: "",
      screenTitle: "アカウント削除",
      screenId: "MBC120",
      messageArea: "",
      desserts: [
        { name: "氏名", inputval: "", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "氏名（フリガナ）", inputval: "", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "会社名", inputval: "", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "会社名（フリガナ）", inputval: "", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "郵便番号", inputval: "", placeholderChrs: "ハイフンなしで入力してください", pswdFlg: false, requiredFlg: true },
        { name: "住所", inputval: "", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "電話番号", inputval: "", placeholderChrs: "ハイフンなしで入力してください", pswdFlg: false, requiredFlg: true },
        { name: "メールアドレス", inputval: "", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "メールアドレス(確認)", inputval: "", placeholderChrs: "", pswdFlg: false, requiredFlg: true },
        { name: "パスワード", inputval: "", placeholderChrs: "", pswdFlg: true, requiredFlg: true },
        { name: "パスワード(確認)", inputval: "", placeholderChrs: "", pswdFlg: true, requiredFlg: true },
      ],
      kbnTypPolicy: "200",
      KbnCdService: "0",
      unsubscribeCheck: false,
      pswdFlg: false,
      password: "Password",
      contactUsDspFlg: false,
      moveTopButtonPos: "",
      notes: "",
      isProcessing: false,
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
        emailMatch: () => "The email and password you entered don't match",
      },
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },
      dlgMsgCompd: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgCompd.isOpen = false;
          this.$router.push(this.$router.resolve({ name: "PSS100" }).href);
        },
      }
    };
  },
  created() {
    this.initialize();
  },
  methods : {

   /*
    * 初期表示
    */
    initialize() {
      this.setAuthUserInfo();
      this.messageArea = this.$i18n.t('webmsg.mbc120.area');
      this.getWebContents();
      
    },
    setAuthUserInfo : function() {      
      let authInfo = this.setLoginInfoMixin();
      this.username = authInfo['username'];
      this.companyname = authInfo['companyname'];
    },
   /*
    * WEBコンテンツ取得
    */
    getWebContents : async function() {
      // ログインサービス呼び出し
      let apiurl = Constants.URL_API_MBC120G01;
      let accessToken = this.$store.getters["authcUser/getAccessToken"];
      try {
        // API呼出
        let responseData = await this.$axios.get(apiurl,
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            }); 
        this.displyWebContents(responseData.data);
      } catch(error) {
          this.dlgMsg.msg = this.$i18n.t('msg.err.cm100', ['アカウント']);
          this.dlgMsg.isOpen = true;
          this.desserts.push({});
      } 
      // finally {
      //   this.loading = false;
      // }
    },
    
    /*
    * WEBコンテンツ表示
    */
    displyWebContents : function(responseData) {
      this.desserts = new Array();
      if (responseData == null) {
        return;
      }
      this.notes = responseData.data;
    },



    /*
    * 削除ボタン押下
    */
    suspend: async function () {
      if (this.isProcessing) return;
      this.isProcessing = true;
      // チェック処理
      if (!this.unsubscribeCheck) {
        this.dlgMsg.msg = this.$i18n.t('msg.err.mb011');
        this.dlgMsg.isOpen = true;
        this.isProcessing = false;
        return;
      }

      //アカウント削除サービス呼び出し
      let responseData = null;
      let apiErrorInfo = null;
      try {
        let accessToken = this.$store.getters["authcUser/getAccessToken"];
        let loggedUserInfo = this.$store.getters["authcUser/getLoggedUserInfo"];
        let apiurl = Constants.getUrlApiMBC120P01(loggedUserInfo['id']);
        // 入力データ
        let data = JSON.stringify(this.deleteAccountData());
        // API呼出
        let response = await this.$axios.put(apiurl, data, 
            {
               headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken},
              responseType: "json",
            }); 
        responseData = response.data;
        console.log(response);
      } catch(error) {
        console.log(error);
        apiErrorInfo = error;
      } finally {
        this.isProcessing = false;
        this.loading = false;
      }
      // 完了メッセージ表示 & 次画面遷移
      this.showDialogMsgAfterAPICall(apiErrorInfo, responseData);
    },

    /*
    * キャンセルボタン押下
    */
    cancel: function() {
      let srcScreenId = this.$route.params['srcScreenId'];
      if (srcScreenId == null) { 
        this.$router.push(this.$router.resolve({ name: "MBR100" }).href);
      } else {
         this.$router.push(this.$router.resolve({ name: srcScreenId }).href);
      }
    },
    
    /*
    * 完了メッセージ表示
    */
    showDialogMsgAfterAPICall : function(apiErrorInfo, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        this.dlgMsg.msg = this.$i18n.t('msg.err.cm113', ['アカウント']);
        this.dlgMsg.isOpen = true;
        return hasError;
      }
      // APIコール正常
      if (responseData.statusCd === 200) {
        // 処理正常
        hasError = false;
        this.dlgMsgCompd.msg = responseData.message ;
        this.dlgMsgCompd.isOpen = true;
        return hasError;
      } else {
        // 処理異常
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          this.dlgMsg.msg = Utils.createMsgViewStringForErrList(errorList);
          this.dlgMsg.isOpen = true;
          return hasError;
        }else{
          this.dlgMsg.msg = responseData.message ;
          this.dlgMsg.isOpen = true;
          return hasError;
        }
      }
    },

     /*
      * 削除用データ生成
      */
    deleteAccountData : function() {
      let deleteData = {};
      deleteData['unsubscribeCheck'] = this.unsubscribeCheck;
      return deleteData;
    },
  },
};
</script>

<style scoped>


.under {
  background: linear-gradient(transparent 40%, #ff99ab 70%);
}

.simple-table {
  table-layout: auto;
  width: 96%;
  margin: 40px 20px;
}
.table-title {
  background-color: #f2f2f2;
  width: 20%;
  font-size: 0.9em !important;
  text-align: left;
}
.table-title-required {
  background-color: #f2f2f2;
  width: 10%;
  text-align: right;
}
.table-td-1 {
  display: flex;
  text-align: left;
  padding: 6px 6px !important;
  background-color: #f2f2f2;
}

@media screen and (max-width: 750px) {
  .simple-table {
    table-layout: auto;
    width: 96%;
    margin: 5px 5px;
  }
  .table-title {
    background-color: #f2f2f2;
    width: 34%;
    font-size: 0.9em !important;
    text-align: left;
  }
  .table-title-required {
    background-color: #f2f2f2;
    width: 20%;
    text-align: right;
  }
}
</style>